// extracted by mini-css-extract-plugin
export default {"recos":"r4-z","productCardOverride":"s4-z","rowHasBadge":"t4-z"};